import React from 'react';
import {Slider, Tooltip} from "@nextui-org/react";

const SliderWithInput = ({label, maxValue, minValue, onChange, value, description
}: {
    label: string,
    maxValue: number,
    minValue: number,
    onChange: (value: number) => void,
    value: number,
    description?: string
}) => {
    const [v, setV] = React.useState(value);
    const [inputValue, setInputValue] = React.useState(value.toString());

    const handleChange = (value: any) => {
        if (isNaN(Number(value))) return;

        setV(Number(value));
        setInputValue(value.toString());
        onChange(Number(value))
    };

    return (
        <div className={'mb-2'}>
            <Slider
                label={label}
                size="sm"
                step={maxValue < 1 ? 0.01 : 1}
                maxValue={maxValue}
                minValue={minValue}
                color="foreground"
                classNames={{
                    //base: "max-w-md",
                    label: "text-medium"
                }}
                // we extract the default children to render the input
                renderValue={({children, ...props}) => (
                    <output {...props}>
                        <Tooltip
                            className="text-tiny text-default-500 rounded-md"
                            content="Press Enter to confirm"
                            placement="left"
                        >
                            <input
                                className="px-1 py-0.5 w-14 text-right text-small text-default-700 font-medium bg-default-100 outline-none transition-colors rounded-small border-medium border-transparent hover:border-primary focus:border-primary"
                                type="text"
                                aria-label="Temperature value"
                                value={inputValue}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    handleChange(v)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && !isNaN(Number(inputValue))) {
                                        setV(Number(inputValue));
                                        onChange(Number(v))
                                    }
                                }}
                            />
                        </Tooltip>
                    </output>
                )}
                value={v}
                onChange={handleChange}
            />
            {description && <p className="text-default-500 font-medium text-small">{description}</p>}
        </div>
    );
};

export default SliderWithInput;